<template>
    <div class="main-nav">
        <div class="classify-stage">
            <div class="classify-rail"></div>
            <div class="classify-row">
                <button
                    v-for="item in displayClassArr"
                    :key="item.id"
                    type="button"
                    class="class-chip"
                    :class="{ active: activeClassify === item.classify }"
                    @click="switchClass(item)"
                >
                    {{ item.classify }}
                </button>
                <button
                    type="button"
                    class="class-chip video-chip"
                    @click="goVideoPage"
                >
                    在线观看
                </button>
            </div>
        </div>

        <div class="app-icon-grid">
            <button
                v-for="item in dataList"
                :key="item.id"
                type="button"
                class="app-icon-btn"
                @click="toPath(item)">
                <img class="item-image" :src="item.pic" alt="" />
                <span class="item-title">{{ item.title }}</span>
                <span class="item-download">下载</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        displayClassArr() {
            const list = Array.isArray(this.classArr) ? this.classArr : []
            if (list.length >= 3) return list.slice(0, 3)
            const fallback = [
                { id: 'f1', classify: '热门推荐' },
                { id: 'f2', classify: '深夜视频' },
                { id: 'f3', classify: '午夜直播' }
            ]
            return [...list, ...fallback].slice(0, 3)
        }
    },
    data() {
        return {
            classArr: [
                { id: 1, classify: "热门推荐" },
                { id: 2, classify: "深夜视频" },
                { id: 3, classify: "午夜直播" },
            ],
            dataList: [],
            activeClassify: ''
        }
    },
    methods: {
        // 获取分类
        async getSet() {
            const { data: res } = await this.$http.get('/classify')
            const list = Array.isArray(res.data) ? res.data : []
            this.classArr = list.length ? list : this.classArr
            const first = this.displayClassArr[0]
            if (first && first.classify) {
                this.switchClass(first)
            }
        },
        // 获取对应分类的应用
        async getListClass(title) {
            const { data: res } = await this.$http.get('/list_class',{
                params: {class: title}
            })
            const list = Array.isArray(res.data) ? res.data : []
            this.dataList = list
        },
        switchClass(item) {
            const title = item && item.classify ? item.classify : ''
            if (!title) return
            this.activeClassify = title
            this.getListClass(title)
        },
        goVideoPage() {
            this.$router.push('/video')
        },
        // 先同步打开链接，避免移动端拦截弹窗；再异步上报点击
        toPath(itemInfo) {
            if (!itemInfo || !itemInfo.url) return

            const popup = window.open(itemInfo.url, '_blank')
            if (!popup) {
                window.location.href = itemInfo.url
            }

            this.$http.post('/track_click', {
                target_type: 'app',
                target_id: itemInfo.id
            }).catch(() => {
                // 统计失败不阻断下载跳转
            })
        }
    },
    created() {
        this.getSet()
    }
}
</script>

<style lang="less" scoped>
.main-nav {
    border-radius: .9rem;
    padding: .52rem;
    background: linear-gradient(180deg, rgba(34, 8, 93, .98), rgba(26, 7, 74, .98));
    border: 1px solid rgba(128, 93, 233, .62);
    box-shadow: var(--a-shadow);
    overflow: hidden;
}

.classify-stage {
    position: relative;
    border-radius: .72rem;
    padding: .35rem;
    margin-bottom: .62rem;
    background: linear-gradient(92deg, rgba(98, 38, 228, .84), rgba(219, 76, 207, .8));
    border: 1px solid rgba(189, 161, 255, .6);
}

.classify-rail {
    position: absolute;
    left: .45rem;
    right: .45rem;
    bottom: .1rem;
    height: .24rem;
    border-radius: 99px;
    background: rgba(53, 14, 138, .88);
}

.classify-row {
    position: relative;
    z-index: 2;
    display: flex;
    width: 100%;
    gap: .4rem;
}

.class-chip {
    flex: 1;
    border: 1px solid rgba(222, 209, 255, .72);
    background: rgba(62, 31, 149, .9);
    color: #f2e9ff;
    padding: .42rem .42rem;
    border-radius: .45rem;
    font-size: .9rem;
    font-weight: 700;
    text-align: center;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15);
    transition: all .2s ease;
}

.class-chip.active {
    background: linear-gradient(120deg, #8445f8, #e85fd2);
    color: #fff;
    border-color: rgba(255, 255, 255, .9);
    box-shadow: 0 8px 14px rgba(20, 7, 62, .48);
}

.video-chip {
    flex: 1;
    min-width: 0;
}

.app-icon-grid {
    margin-top: .1rem;
    display: flex;
    flex-wrap: wrap;
    gap: .62rem .52rem;
    width: 100%;
}

.app-icon-btn {
    width: calc((100% - 2.08rem) / 5);
    border: 1px solid rgba(122, 87, 228, .45);
    background: linear-gradient(180deg, rgba(73, 30, 174, .56), rgba(34, 12, 95, .72));
    padding: .25rem .22rem .34rem;
    min-width: 0;
    flex: 0 0 calc((100% - 2.08rem) / 5);
    border-radius: .75rem;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .14), 0 10px 18px rgba(11, 3, 38, .36);
}

.item-image {
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    border-radius: .65rem;
    border: 1px solid rgba(170, 144, 244, .35);
    box-shadow: 0 8px 16px rgba(9, 2, 31, .42);
    object-fit: cover;
}

.item-title {
    color: #ffffff;
    display: block;
    font-size: .76rem;
    font-weight: 700;
    line-height: 1.15;
    margin-top: .22rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.item-download {
    display: block;
    margin: .28rem auto 0;
    min-width: 4rem;
    max-width: 4.2rem;
    line-height: 1.24rem;
    text-align: center;
    color: #ffffff;
    font-size: .78rem;
    border: 1px solid rgba(255, 255, 255, .88);
    border-radius: 999px;
    background: linear-gradient(180deg, rgba(125, 84, 227, .52), rgba(73, 42, 157, .44));
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .36), 0 6px 10px rgba(14, 5, 43, .3);
}

@media screen and (max-width: 360px) {
    .main-nav {
        padding: .45rem;
    }
    .classify-row {
        gap: .3rem;
    }
    .app-icon-grid {
        gap: .58rem .38rem;
    }
    .app-icon-btn {
        width: calc((100% - 1.14rem) / 4);
        flex: 0 0 calc((100% - 1.14rem) / 4);
    }
}

@media screen and (max-width: 330px) {
    .app-icon-grid {
        gap: .5rem .32rem;
    }
    .app-icon-btn {
        width: calc((100% - .96rem) / 4);
        flex: 0 0 calc((100% - .96rem) / 4);
    }
}
</style>